<div *ngIf="showMap" class="map">
    add map here
    <!-- <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [scrollwheel]="false" (idle)="mapIdle()" (mapReady)="mapReady($event)" (boundsChange)="mapBoundsChanged($event)" [streetViewControl]="false">
        <agm-marker *ngFor="let providerMarker of providerMarkers" [latitude]="providerMarker.latitude" [longitude]="providerMarker.longitude" [title]="providerMarker.name"></agm-marker>
    </agm-map> -->
</div>
